module.exports = __webpack_public_path__ + "img/Seccion-4.99a3a2db.png";